export const environment = {
  production: false,
  apiUrl: 'https://patients-devices.dev.mycaire.com/api',
  socketUrl: 'http://localhost:5000',
  telemetryApiUrl: 'https://telemetrydata.dev.mycaire.com/api'
};